import React,{useEffect} from 'react'
import '../CSS/Resume.css'
import resumePdf from '../Components/Assets/ANTUAN-FURTCH-Resume.pdf'

const Resume = () => {

  useEffect(()=>{window.scrollTo(0,0);},[]);

  return (
    <div className="resume-container">
      <div className="resume-header">
        <h1 className="resume-name">ANTUAN FURTCH</h1>
        <p className="resume-location">Maricopa, Arizona</p>
        <div className="resume-contact">
          <span>(602)-349-0301 (Text)</span>
          <span>Studynpaste@gmail.com</span>
          <span>GitHub: StudynPaste</span>
        </div>
        <a href={resumePdf} download="Antuan-Furtch-Resume.pdf" className="download-btn">Download PDF</a>
      </div>

      <div className="resume-section">
        <h2 className="section-title">PROFESSIONAL SUMMARY</h2>
        <p className="section-content">
          Frontend Developer specializing in React, JavaScript, HTML, and CSS with experience building responsive,
          mobile-friendly websites and reusable UI components. Strong understanding of modern layout techniques including
          Flexbox and CSS Grid. Passionate about creating clean user interfaces and continuously improving technical skills.
          Seeking an entry-level Software Engineer opportunity to contribute technical skills while continuing to learn professional strategies.
        </p>
      </div>

      {/* Technical Skills */}
      <div className="resume-section">
        <h2 className="section-title">TECHNICAL SKILLS</h2>
        <div className="skills-grid">
          <div className="skill-category">
            <h3>Languages</h3>
            <p>JavaScript, HTML5, CSS3</p>
          </div>
          <div className="skill-category">
            <h3>Frontend</h3>
            <p>React, Bootstrap</p>
          </div>
          <div className="skill-category">
            <h3>Backend</h3>
            <p>Node.js, Express.js, MongoDB</p>
          </div>
          <div className="skill-category">
            <h3>Tools</h3>
            <p>Git, GitHub, VS Code, EchoAPI, Chrome DevTools, Figma</p>
          </div>
          <div className="skill-category">
            <h3>Development</h3>
            <p>Responsive Design, UI/UX Principles, Performance Basics, Reusable Components, State Management Fundamentals, Data-Driven UI Rendering</p>
          </div>
        </div>
      </div>

      {/* Project Experience */}
      <div className="resume-section">
        <h2 className="section-title">PROJECT EXPERIENCE</h2>
        
        <div className="project">
          <div className="project-header">
            <h3>MarieMadeIt E-Commerce Website</h3>
            <span className="project-type">Full-Stack | 2023 – Present</span>
          </div>
          <p className="project-link">Website: <a href="https://mariemadeit.com" target="_blank" rel="noopener noreferrer">Mariemadeit.com</a></p>
          <p className="project-tech"><strong>Technologies:</strong> React.js, Node.js, Express.js, MongoDB, Square API, JavaScript, CSS</p>
          <ul className="project-details">
            <li>Developed a full-stack e-commerce web application using the MERN stack</li>
            <li>Integrated Square payment processing for checkout functionality</li>
            <li>Designed layouts using Flexbox and CSS Grid</li>
            <li>Created UI layouts with product descriptions and action buttons</li>
          </ul>
        </div>

        <div className="project">
          <div className="project-header">
            <h3>Rodgers Consulting Services</h3>
            <span className="project-type">Front-End - 2026</span>
          </div>
          <p className="project-link">Website: <a href="https://inficonsult.com" target="_blank" rel="noopener noreferrer">Inficonsult.com</a></p>
          <ul className="project-details">
            <li>Developed a multi-page informational website</li>
            <li>Implemented responsive layouts for desktop, tablet, and mobile</li>
            <li>Organized modular CSS for maintainable styling</li>
            <li>Optimized images and layout spacing for better UX</li>
          </ul>
        </div>
        <div className="project">
          <div className="project-header">
            <h3>Prestige Online Supply House</h3>
            <span className="project-type">Full-Stack - 2026</span>
          </div>
          <p className="project-link">Website: <a href="#" target="_blank" rel="noopener noreferrer">-</a></p>
          <ul className="project-details">
            <li>Developed a full-stack e-commerce web application using the MERN stack</li>
            <li>Implemented responsive layouts for desktop, tablet, and mobile</li>
            <li>Organized modular CSS for maintainable styling</li>
            <li>Optimized images and layout spacing for better UX</li>
          </ul>
        </div>
        <div className="project">
          <div className="project-header">
            <h3>MarieMadeIt Tester</h3>
            <span className="project-type">Front-End - 2024</span>
          </div>
          <p className="project-link">Website: <a href="https://mariemadeit-tester.netlify.app" target="_blank" rel="noopener noreferrer">Mariemadeit-tester.netlify.app</a></p>
          <ul className="project-details">
            <li>Developed a contact form that allows users to apply for tester calls directly to email using EmailJS</li>
            <li>Implemented form validation and controlled inputs</li>
          </ul>
        </div>
      </div>

      {/* Education */}
      <div className="resume-section">
        <h2 className="section-title">EDUCATION</h2>
        <div className="education">
          <h3>Independent Study</h3>
          <p className="education-date">2023 – Present</p>
          <p className="education-description">
            Training focused on React development, modern JavaScript, responsive design, UI components, and frontend 
            performance fundamentals. Finished multiple 6-10 month courses that target Front and Back-end development.
          </p>
        </div>
      </div>
    </div>
  )
}

export default Resume
